import { api } from "@api/api";

function formatSyncName(): string {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `Sincronização ERP - ${day}/${month}/${year} ${hours}:${minutes}`;
}

/**
 * Dispara a sincronização dos planos ERP no dashboard.
 * Usar quando não houver planos ERP retornados para o convênio.
 * POST v1/report/ com type "erp-plans-dashboard" e header X-Agreement-Id.
 */
export async function syncErpPlansReportService(agreementId: string): Promise<void> {
  await api.post(
    "v1/report/",
    {
      type: "erp-plans-dashboard",
      name: formatSyncName(),
    },
    {
      headers: {
        "X-Agreement-Id": String(agreementId),
      },
    }
  );
}
